import * as ReqType from '../types/ServerRequests';
import LoginServices from './LoginServices';
import Axios, { AxiosResponse } from 'axios';
/**
 * Cette classe permet la communication entre le backend et le frontend
 * Elle assure l'envois la reception des données entre le backend et frontend
 * Elle permet la creation, modification, et suppression des Niveaux liés à un cours
 */
export class NiveauService {
    private static instance: NiveauService = new NiveauService();

    public static getInstance(): NiveauService {
        return this.instance;
    }

    /**
     * retourne une liste de niveau
     * @returns {Promise<Niveau[]>}
     */
    public getNiveauList(): Promise<ReqType.Niveau[]> {
        const token = LoginServices.getInstance().getUserToken();
        return Axios.get(
            process.env.REACT_APP_LEVEL_LIST_URL!,
            {
                headers: { 'X-Access-Token': token },
            }
        ).then(
            (response: AxiosResponse<ReqType.Niveau[]>) => {
                return response.data;
            }
        );
    }

    /**
     * retourne le niveau par defaut
     * @returns {Niveau}
     */
    public getDefaultNiveau(): ReqType.Niveau {
        const retVal: ReqType.Niveau = {
            description: '',
            id: -1,
            intitule: '',
        };
        return (retVal);
    }
}


// WEBPACK FOOTER //
// ./src/services/NiveauService.tsx